module.exports = __webpack_public_path__ + "static/img/15203142241.28cd862.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/15203142241.jpg
// module id = NXX3
// module chunks = 0